



































import Vue from 'vue'
import style from '../style.module.scss'

import selectBodySearchList from './select-body-search-list.vue'

import { DefaultListModel, SelectedItem, TreeListModel, ChildModel } from '../types'

export default Vue.extend({
    name: 'select-searchable-body',
    components: {
        selectBodySearchList
    },
    props: {
        keyword: String,
        multiple: Boolean,
        selectedItems: Array as () => SelectedItem[],
        searchList: Array as () => TreeListModel<ChildModel>[],
        currentValue: Object as () => DefaultListModel,
        placeholder:String
    },
    data() {
        return {
            style: style,
            focused: false,
            showSearchList: false,
            showPlaceholder:true
        }
    },
    mounted() {
        document.addEventListener('mouseup', this.clickHandle);

        this.$on('select-from-list', this.select);
    },
    methods: {
        /**
         * Происходит когда выбран элемент
         */
        select(item: DefaultListModel) {
            this.$emit('select', item);
            if(!this.multiple) {
                this.toggle(false);
            }
        },
        clickHandle(event: MouseEvent): void {
            const target = event.target as Element;
            const targetContains = this.$el.contains(target);
            const textElement = this.$refs.text as HTMLElement;

            if(targetContains && !this.focused) {

                this.toggle(true)

                this.$nextTick(() => {
                    textElement.focus();
                })
            }

            this.toggle(targetContains);
        },
        toggle(isFocused: boolean) {
            this.focused = isFocused;
            this.$emit('toggle', isFocused);
        }
    }
})
